window.addEventListener('load', function () {
    baguetteBox.run('.gallery-content', {
        animation: 'fadeIn',
        noScrollbars: true,
        async: true,
        overlayBackgroundColor: 'rgba(0,0,0,0.3)'
    });


    // Remove anchor to gallery when gallery is empty or unset
    const gallery = document.getElementById('gallery');

    if(document.getElementById('galleryLink') != null){
        if(gallery != null){
            $("#galleryLink").css('opacity',1);
        }
        else{
            document.getElementById('galleryLink').remove();
        }
    }
});


